import React, { useEffect, useState } from 'react';
import AdminWrapper from "./AdminWrapper";
import SwitchMenuBar from '../../Components/SwitchMenuBar/SwitchMenuBar';
import { Button, Link, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Checkbox } from '@mui/material';
import { API } from '../../API';
import { statusInvoice } from '../../Helper';
import moment from 'moment/moment';
import { APIMETHOD } from '../../v2/API';
import { customer } from '../../v2/endpoints/customer';
import FormControlInput from '../../Components/FormControl/FormControl';
import debounce from 'lodash/debounce';
import ModalComponent from '../../Components/Modal/Modal';
import { notify } from 'react-notify-toast';
import Spinner from '../../Components/Spinner/Spinner';

export default function AllInvoiceTable(props) {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isSelectedInvoiceIDs, setIsSelectedInvoiceIDs] = useState([]);
    const [isOpenPopup, setIsOpenPopup] = useState(false);
    const [showInvoiceRef, setShowInvoiceRef] = useState(null);
    const [invoiceRefID, setInvoiceRefID] = useState(null);
    const [showInvoiceRefNo, setShowInvoiceRefNo] = useState(null);
    const [invoiceRefNo, setInvoiceRefNo] = useState(null);
    const [totalRecords, setTotalRecords] = useState(0);
    const [paymentDate, setPaymentDate] = useState([]);
    const [filterOption, setFilterOption] = useState({ campus: "", duo_date: "", period_date: "", status: "", customer_id: "", approver: "" });
    const [allCampuses, setAllCampuses] = useState([]);
    const [allCustomers, setAllCustomers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenUnPaidPopup, setIsOpenUnPaidPopup] = useState(false);
    const [approvers, setApprovers] = useState([]);
    const [campusByInst, setCampusByInst] = useState([]);
    const [isOpenInvoiceLogPopup, setIsOpenInvoiceLogPopup] = useState(false);
    const [invoiceLog, setInvoiceLog] = useState([]);
    const history = props.history
    const onChangeValue = debounce((key, value) => {
        const newValue = {
            ...filterOption,
            [key]: value
        }
        setFilterOption(newValue)
    }, 0);

    useEffect(() => {
        getInvoices(1, 10, filterOption);
        fetchPaymentDate();
        API.getAllCampusWithCache().then(result => {
            setAllCampuses(result?.data);
            setCampusByInst(result?.data);
        });
        API.allCustomers().then(result => {
            const customers = result?.data
            .map((cus) => {
                if (cus.institution_name) {
                    return cus;
                } else if (cus?.institution_id?.institution_name) {
                    return {
                        ...cus,
                        institution_name: cus.institution_id.institution_name
                    };
                } else {
                    return null; // Return null for customers without institution_name
                }
            })
            .filter(cus => cus !== null)
            .sort((a, b) => {
                const nameA = a?.institution_name || '';
                const nameB = b?.institution_name || '';
                return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
            });
            setAllCustomers(customers);
        });
        API.listApproversInAdmin().then(result => {
            setApprovers(result.data.data);
        });
    }, []);

    const getInvoices = (page, limit, filter_options) => {
        setIsLoading(true);
        API.listInvoicesInAdmin(page, limit, filter_options).then(result => {
            setData(result?.data?.invoices);
            setTotalRecords(result?.data?.paginate?.total_record);
            setIsLoading(false);
        })
    }

    const fetchPaymentDate = () => {
        APIMETHOD.get(customer.fetchPaymentDate, {}).then(result => {
            const sortedDates = [...result?.data]?.sort((a, b) => {
                const momentA = moment(a.fortnight_end_date, 'DD/MM/YYYY');
                const momentB = moment(b.fortnight_end_date, 'DD/MM/YYYY');
                return momentB - momentA;
            });
            setPaymentDate(sortedDates);
        });
    }

    const CampusCell = ({ campuses }) => (
        <div className="can-deliver-cell-container">
            {campuses?.map((campus, index) => (
                <div key={index} className="can-deliver-cell-child-element">
                    {campus.campus_shortname + ' - ' + campus.suburb}
                </div>
            ))}
        </div>
    );

    const toggleSelectInvoices = (e) => {
        const invoiceId = e.target.id;

        // Create a copy of the current isSelectedInvoiceIDs array
        const updatedSelectedIDs = [...isSelectedInvoiceIDs];

        if (e.target.checked) {
            // If the checkbox is checked, add the invoiceId to the array
            updatedSelectedIDs.push(invoiceId);
        } else {
            // If the checkbox is unchecked, remove the invoiceId from the array
            const index = updatedSelectedIDs.indexOf(invoiceId);
            if (index > -1) {
                updatedSelectedIDs.splice(index, 1);
            }
        }

        // Update the state with the new array of selected IDs
        setIsSelectedInvoiceIDs(updatedSelectedIDs);
    }

    const handleChangeRef = (invoice_id) => {
        const invoiceData = {
            invoice_number: invoiceRefID
        };
        setShowInvoiceRef(false);
        API.updateInvoiceForCustomer(invoice_id, invoiceData).then(() => {
            setData((prevData) => {
                return prevData.map((invoice) => {
                    if (invoice_id === invoice._id) {
                        return {
                            ...invoice,
                            invoice_number: invoiceRefID,
                        };
                    }
                    return invoice;
                });
            });
        });
    }

    const handleChangeRefNo = (invoice_id) => {
        const invoiceData = {
            ref_id: invoiceRefNo
        };
        setShowInvoiceRefNo(false);
        API.updateInvoiceForCustomer(invoice_id, invoiceData).then(() => {
            setData((prevData) => {
                return prevData.map((invoice) => {
                    if (invoice_id === invoice._id) {
                        return {
                            ...invoice,
                            ref_id: invoiceRefNo,
                        };
                    }
                    return invoice;
                });
            });
        });
    }

    const handleMarkAsPaidInvoices = () => {
        API.markAsPaidInvoices(isSelectedInvoiceIDs).then(() => {
            setData((prevData) => {
                return prevData.map((invoice) => {
                    if (isSelectedInvoiceIDs.includes(invoice._id)) {
                        return {
                            ...invoice,
                            status: 'Paid',
                        };
                    }
                    return invoice;
                });
            });
        });
        setIsOpenPopup(false);
    }

    const handleMarkAsUnPaidInvoices = () => {
        API.markAsUnPaidInvoices(isSelectedInvoiceIDs).then((data) => {
            setData((prevData) => {
                return prevData.map((invoice) => {
                    const updatedInvoice = data.data.data.find((invoiceData) => invoiceData._id === invoice._id);

                    return updatedInvoice ? { ...invoice, status: updatedInvoice.status } : invoice;
                });
            });
        });
        setIsOpenUnPaidPopup(false);
    }

    const handleChangeRowsPerPage = (event) => {
        setPageSize(parseInt(event.target.value, 10));
        getInvoices(1, parseInt(event.target.value, 10), filterOption);
        setCurrentPage(0);
    };

    const handleChangePage = (event, newPage) => {
        getInvoices(newPage + 1, pageSize, filterOption);
        setCurrentPage(newPage);
    };

    const handleFilter = () => {
        const keys = Object.keys(filterOption)
        keys.forEach(key => {
            if (filterOption[key] === '') filterOption[key] = ''
        })

        getInvoices(1, 10, filterOption);
    }

    const handleOpenPopup = () => {
        if (isSelectedInvoiceIDs.length === 0) {
            notify.show('Please select at least one invoice');
            return;
        }
        setIsOpenPopup(true);
    }

    const handleUnpaidPopup = () => {
        if (isSelectedInvoiceIDs.length === 0) {
            notify.show('Please select at least one invoice');
            return;
        }
        setIsOpenUnPaidPopup(true);
    }

    const clearFilter = () => {
        const keys = Object.keys(filterOption)
        keys.forEach(key => {
            filterOption[key] = ''
        })

        setCampusByInst(allCampuses);

        getInvoices(1, 10, filterOption);
    }

    const customerFilter = (event) => {
        if(event.target.value) {
            onChangeValue("customer_id", event.target.value);
            let customer = allCustomers.find(c => c._id === event.target.value);
            API.listCampusesByInstId(customer.institution_id._id).then((result) => {
                setCampusByInst(result.data.data);
            });
        } else {
            setCampusByInst(allCampuses);
        }
    }

    const handleOpenInvoiceLog = (invoice_id) => {
        setIsOpenInvoiceLogPopup(true);
        API.invoiceLogsById(invoice_id).then((result) => {
            console.log(result?.data?.data)
            setInvoiceLog(result?.data?.data);
        });
    }

    return (
        <AdminWrapper>
            <SwitchMenuBar isViewAsTeacher />
            <div className="all-availability-table-container">
                {
                    isOpenPopup && (<ModalComponent
                        show={true}
                        className="share-profile-modal-new"
                        header="Mark as Paid Invoices"
                        onClose={() => {
                            setIsOpenPopup(false)
                        }}
                    >
                        <div className="row">
                            <div className="col-12">
                                <div className="form-field mb-3">
                                    <div className="form-input">
                                    </div>
                                    <h4 className="mt-2 text-info text center">
                                        Are you sure you want to mark as paid?
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <button onClick={() => setIsOpenPopup(false)} className="btn btn-block secondary-button-no-margin-hover btn-c button-component">Cancel</button>
                            </div>
                            <div className="col-md-6">
                                <button className="btn btn-primary btn-block primary-button-no-margin-hover btn-c button-component" onClick={handleMarkAsPaidInvoices}>Submit</button>
                            </div>
                        </div>
                    </ModalComponent>)
                }

{
                    isOpenInvoiceLogPopup && (<ModalComponent
                        show={true}
                        className="share-profile-modal-new"
                        header=" Detail invoice logs"
                        onClose={() => {
                            setIsOpenInvoiceLogPopup(false)
                        }}
                    >
                        <div className="modal-body">
                            <div className='row'>
                                <div className="col-12">
                                    {
                                        invoiceLog && invoiceLog.map(item => {
                                            return (
                                                <div key={item._id}>
                                                    <b>Draft invoice {'>'}</b> {item?.status} { 
                                                    (item?.actor ?(item?.actor?.first_name + ' ' + item?.actor?.last_name) || 
                                                    (item?.actor?.personnel_first_name + ' ' + item?.actor?.personnel_last_name) : 'System')} 
                                                    {' '} On {moment(item.createdAt).tz('Australia/Melbourne').format('DD/MM/YYYY')} 
                                                    {' '} at {moment(item.createdAt).tz('Australia/Melbourne').format('HH:mm')}
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        </div>

                    </ModalComponent>)
                }

                {
                    isOpenUnPaidPopup && (<ModalComponent
                        show={true}
                        className="share-profile-modal-new"
                        header="Mark as Unpaid Invoices"
                        onClose={() => {
                            setIsOpenUnPaidPopup(false)
                        }}
                    >
                        <div className="row">
                            <div className="col-12">
                                <div className="form-field mb-3">
                                    <div className="form-input">
                                    </div>
                                    <h4 className="mt-2 text-info text center">
                                        Are you sure you want to mark as unpaid?
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <button onClick={() => setIsOpenUnPaidPopup(false)} className="btn btn-block secondary-button-no-margin-hover btn-c button-component">Cancel</button>
                            </div>
                            <div className="col-md-6">
                                <button className="btn btn-primary btn-block primary-button-no-margin-hover btn-c button-component" onClick={handleMarkAsUnPaidInvoices}>Submit</button>
                            </div>
                        </div>
                    </ModalComponent>)
                }
                <h1 className="text-3xl font-bold text-center">All Invoices</h1>
                <div className="card-body page-container-inner">
                    <Paper sx={{ width: '100%', mb: 2 }}>
                        <FormControlInput
                            inputLabel={"Customer"}
                            label={"Customer"}
                            value={filterOption.customer_id}
                            onChange={event => customerFilter(event)}
                        >
                            {
                                allCustomers && allCustomers
                                    ?.sort((a, b) => {
                                        const nameA = a?.institution_name || '';
                                        const nameB = b?.institution_name || '';
                                        return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
                                    })
                                    .map(item => {
                                        return <MenuItem value={item._id}>{item?.institution_name}</MenuItem>
                                    })
                            }
                        </FormControlInput>
                        <FormControlInput
                            inputLabel={"Campus"}
                            label={"Campus"}
                            value={filterOption.campus}
                            onChange={event => onChangeValue("campus", event.target.value)}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {
                                campusByInst && campusByInst?.map(item => {
                                    return (item?.campus_shortname ? <MenuItem value={item._id}>{item.campus_shortname + ' - ' + item.suburb}</MenuItem> : '')
                                })
                            }
                        </FormControlInput>
                        <FormControlInput
                            inputLabel={"Period"}
                            label={"Period"}
                            value={filterOption.period_date}
                            onChange={event => onChangeValue("period_date", event.target.value)}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {
                                paymentDate && paymentDate.map(item => {
                                    return <MenuItem value={item.fortnight_start_date + '-' + item.fortnight_end_date}>{item.fortnight_start_date + ' - ' + item.fortnight_end_date}</MenuItem>
                                })
                            }
                        </FormControlInput>
                        <FormControlInput
                            inputLabel={"Due"}
                            label={"Due"}
                            value={filterOption.duo_date}
                            onChange={event => onChangeValue("duo_date", event.target.value)}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {
                                paymentDate && [...new Set(paymentDate.map(item => item.teachers_payment_date))].map(item => {
                                    return <MenuItem value={item}>{item}</MenuItem>
                                })
                            }
                        </FormControlInput>
                        <FormControlInput
                            inputLabel={"Approvers"}
                            label={"Approvers"}
                            value={filterOption.approver}
                            onChange={event => onChangeValue("approver", event.target.value)}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {
                                approvers && approvers?.map(item => {
                                    return <MenuItem value={item._id}>{item.full_name}</MenuItem>
                                })
                            }
                        </FormControlInput>

                        <FormControlInput
                            inputLabel={"Status"}
                            label={"Status"}
                            value={filterOption.status}
                            onChange={event => onChangeValue("status", event.target.value)}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {
                                statusInvoice && statusInvoice.map(item => {
                                    return <MenuItem value={item.name}>{item.name}</MenuItem>
                                })
                            }
                        </FormControlInput>
                        <Button sx={{ m: 1 }} size="large" className="btn-primary text-white" variant="outlined" onClick={handleFilter}>Apply</Button>
                        <Button onClick={clearFilter} sx={{ m: 1 }} size="large" variant="outlined">Clear Filter</Button>
                        <TableContainer>
                            <button className='btn secondary-button-no-margin-hover btn-c m-2' onClick={handleOpenPopup}>Mark as Paid</button>
                            <button className='btn mark-button-no-margin-hover btn-c m-2' onClick={handleUnpaidPopup}>Mark as Unpaid</button>
                            <Table
                                aria-labelledby="tableTitle"
                                size={'medium'}
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell width={10}></TableCell>
                                        <TableCell>Customer name</TableCell>
                                        <TableCell>Inv Number</TableCell>
                                        <TableCell>Inv Ref# No</TableCell>
                                        <TableCell width={300}>Campus</TableCell>
                                        <TableCell>Due Date</TableCell>
                                        <TableCell>Period</TableCell>
                                        <TableCell>Approver</TableCell>
                                        <TableCell>Amount</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isLoading ? <Spinner /> :
                                        <>
                                            {data?.length > 0 && data
                                                ?.map((item, index) => (
                                                    <TableRow key={item._id} style={item?.status == 'Under review by RT admin' ? {backgroundColor: 'yellow'} : {}} >
                                                        <TableCell>
                                                            <Checkbox
                                                                value={item._id}
                                                                id={item._id}
                                                                checked={isSelectedInvoiceIDs.includes(item._id)}
                                                                onChange={toggleSelectInvoices}
                                                            >
                                                            </Checkbox>
                                                        </TableCell>
                                                        <TableCell>{item.institution.institution_name}</TableCell>
                                                        <TableCell>
                                                            {
                                                                showInvoiceRef && showInvoiceRef === item._id ?
                                                                    <TextField size='small' onChange={(e) => {
                                                                        let preData = [...data];
                                                                        let object = { ...preData[index] }
                                                                        object.invoice_number = e.target.value;
                                                                        preData[index] = object;
                                                                        setData(preData);
                                                                        setInvoiceRefID(object.invoice_number);
                                                                    }} value={invoiceRefID}></TextField> : item?.invoice_number
                                                            }
                                                        </TableCell>
                                                        <TableCell>
                                                            {
                                                                showInvoiceRefNo && showInvoiceRefNo === item._id ?
                                                                    <TextField size='small' onChange={(e) => {
                                                                        const preData = [...data];
                                                                        const object = { ...preData[index] }
                                                                        object.ref_id = e.target.value;
                                                                        preData[index] = object;
                                                                        setData(preData);
                                                                        setInvoiceRefNo(object.ref_id);
                                                                    }} value={invoiceRefNo}></TextField> : item?.ref_id
                                                            }
                                                        </TableCell>
                                                        <TableCell>{<CampusCell campuses={item.campuses}></CampusCell>}</TableCell>
                                                        <TableCell>{moment(item.invoice_period_start_date, 'YYYY-MM-DD').format("DD/MM/YYYY") + ' to ' + moment(item.invoice_period_end_date, 'YYYY-MM-DD').format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell>{moment(item.invoice_duo_date, 'YYYY-MM-DD').format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell>{item?.personnel ? item?.personnel?.personnel_first_name + ' ' + item?.personnel?.personnel_last_name : item.customer.first_name + ' ' + item.customer.last_name}</TableCell>
                                                        <TableCell>{'$' + parseFloat(item.total_price).toFixed(2)}</TableCell>
                                                        <TableCell>
                                                            {
                                                                item.status === 'Awaiting approval by manager'
                                                                    ? 'Awaiting approval by ' + (item?.personnel ? item?.personnel?.personnel_first_name + ' ' + item?.personnel?.personnel_last_name : item.customer.first_name + ' ' + item.customer.last_name)
                                                                    : item.status
                                                            }
                                                        </TableCell>
                                                        <TableCell>
                                                            <Link
                                                                className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
                                                                onClick={() => {
                                                                    history.push(`/InvoiceDetail/${item._id}`)
                                                                }}
                                                            >
                                                                View
                                                            </Link>
                                                            {
                                                                showInvoiceRef && showInvoiceRef === item._id ?
                                                                    <Button onClick={() => handleChangeRef(item._id)} id={item.customer._id} variant='outlined' className='pl-4 pr-4 mt-2'>Submit</Button>
                                                                    : <Button onClick={(e) => {
                                                                        setShowInvoiceRef(e.target.id);
                                                                        setInvoiceRefID(item.invoice_number);
                                                                    }} id={item._id} variant='outlined' className='p-1 mt-2'>Update Number#</Button>
                                                            }
                                                            {
                                                                showInvoiceRefNo && showInvoiceRefNo === item._id ?
                                                                    <Button onClick={() => handleChangeRefNo(item._id)} id={item.customer._id} variant='outlined' className='pl-4 pr-4 mt-2'>Submit</Button>
                                                                    : <Button onClick={(e) => {
                                                                        setShowInvoiceRefNo(e.target.id);
                                                                        setInvoiceRefNo(item.ref_id);
                                                                    }} id={item._id} variant='outlined' className='p-1 mt-2'>Update Inv Ref# No</Button>
                                                            }
                                                        </TableCell>
                                                        <TableCell>
                                                            <Button onClick={() => handleOpenInvoiceLog(item._id)} variant='outlined' className='pl-4 pr-4 mt-2'>
                                                                Log detail
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            {data?.length === 0 && (
                                                <TableRow
                                                    style={{
                                                        height: 53,
                                                    }}
                                                >
                                                    <TableCell colSpan={9} />
                                                </TableRow>
                                            )}
                                        </>}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={totalRecords}
                            rowsPerPage={pageSize}
                            page={currentPage}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                </div>
            </div>
        </AdminWrapper>
    );
}